export default {
  title: 'Create {level}',
  helperText: 'This modal allows you to create new assets (as long as the license allows you to).',
};
